import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_WOOFY: TStep[] = [
  {
    pageId: PageId.HELLO_WOOFY,
  },
  {
    pageId: PageId.DOG_AGE_WOOFY,
  },
  {
    pageId: PageId.BEHAVIOR_WOOFY,
  },
  {
    pageId: PageId.CHAT_WOOFY,
  },
  {
    pageId: PageId.URGE_WOOFY,
  },
  {
    pageId: PageId.PREPARE_FLOW_WOOFY,
  },
  {
    pageId: PageId.EMAIL_WOOFY,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_WOOFY,
  },
  {
    pageId: PageId.ACCOUNT_WOOFY,
  },
  {
    pageId: PageId.DOWNLOAD_WOOFY,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_WOOFY.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_WOOFY.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
